//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		name: "Footer",
		data(){
			return{
				footerList : [
					{
						icon: 'home.png',
						iconSelected: 'homefill.png',
						url:'/home',
						text:'首页',
						link:'/home',
						name:'home'
					},
					{
						icon: 'product.png',
						iconSelected: 'product_fill.png',

						text:'财务',
            link:'/user/finance',
            name:'product'
					},
					{
						icon: 'computer.png',
						iconSelected: 'computer_fill.png',

						text:'工单',
            link:'/user/gongdan',
            name:'console'
					},
					{
						icon: 'main.png',
						iconSelected: 'main_fill.png',
						url:'/main',
						text:'我的',
            link: '/main',
            name: 'main'
					},
				]
			}
		},
		methods:{
			getRealPath(item){
				let returnVal = {};
				if(this.status==item.name){
					returnVal.url = '../../static/img/'+item.iconSelected;
					returnVal.status = true;
				}else {
					returnVal.url = '../../static/img/'+item.icon;
					returnVal.status = false;
				}
				return returnVal;
			}

		},
		props: ["status"]
	}



// WEBPACK FOOTER //
// ./src/common/Footer.vue